module.exports = __webpack_public_path__ + "img/pr-14.e40e0510.png";